import api from './axios';

export const adminAPI = {
  // Login
  login: async (credentials) => {
    const response = await api.post('/admin/login', credentials);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  },

  // Forgot Password - Send OTP
  forgotPassword: async (email) => {
    const response = await api.post('/admin/forgot-password', { email });
    return response.data;
  },

  // Verify Password Reset OTP
  verifyResetOTP: async (email, otp) => {
    const response = await api.post('/admin/verify-reset-otp', { email, otp });
    return response.data;
  },

  // Reset Password
  resetPassword: async (email, resetToken, newPassword) => {
    const response = await api.post('/admin/reset-password', {
      email,
      resetToken,
      newPassword,
    });
    return response.data;
  },

  // Dashboard Stats
  getDashboardStats: async () => {
    const response = await api.get('/admin/dashboard/stats');
    return response.data;
  },

  // Get all athletes with filters
  getAllAthletes: async (filters) => {
    const params = {};
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params[key] = filters[key];
    });
    const response = await api.get('/admin/athletes', { params });
    return response.data;
  },

  // Get athlete details
  getAthleteDetails: async (athleteId) => {
    const response = await api.get(`/admin/athletes/${athleteId}`);
    return response.data;
  },

  // Update athlete details
  updateAthleteDetails: async (athleteId, data) => {
    const response = await api.put(`/admin/athletes/${athleteId}`, data);
    return response.data;
  },

  // Verify athlete
  verifyAthlete: async (athleteId, data) => {
    const response = await api.put(`/admin/athletes/${athleteId}/verify`, data);
    return response.data;
  },

  // Bulk verify athletes
  bulkVerifyAthletes: async (data) => {
    const response = await api.post('/admin/athletes/bulk-verify', data);
    return response.data;
  },

  // Get pending verifications
  getPendingVerifications: async (filters) => {
    const params = {};
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params[key] = filters[key];
    });
    const response = await api.get('/admin/pending-verifications', { params });
    return response.data;
  },

  // Update medical age
  updateMedicalAge: async (athleteId, data) => {
    const response = await api.patch(`/admin/athletes/${athleteId}/medical-age`, data);
    return response.data;
  },

  // Get athletes by event
  getAthletesByEvent: async () => {
    const response = await api.get('/admin/athletes/by-event');
    return response.data;
  },

  // Delete athlete
  deleteAthlete: async (athleteId) => {
    const response = await api.delete(`/admin/athletes/${athleteId}`);
    return response.data;
  },

  // Bulk delete athletes
  bulkDeleteAthletes: async (athleteIds) => {
    const response = await api.post('/admin/athletes/bulk-delete', { athleteIds });
    return response.data;
  },

  // NEW: Download single athlete invoice
  downloadAthleteInvoice: async (athleteId) => {
    const response = await api.get(`/admin/athletes/${athleteId}/invoice/download`);
    return response.data;
  },

  // NEW: Download single athlete admit card
  downloadAthleteAdmitCard: async (athleteId) => {
    const response = await api.get(`/admin/athletes/${athleteId}/admit-card/download`);
    return response.data;
  },

  // State Association Management
getAllStateAssociations: async (filters) => {
  const params = {};
  Object.keys(filters).forEach((key) => {
    if (filters[key]) params[key] = filters[key];
  });
  const response = await api.get('/admin/state-associations', { params });
  return response.data;
},

getStateAssociationDetails: async (associationId) => {
  const response = await api.get(`/admin/state-associations/${associationId}`);
  return response.data;
},

updateStateAssociationDetails: async (associationId, data) => {
  const response = await api.put(`/admin/state-associations/${associationId}`, data);
  return response.data;
},

verifyStateAssociation: async (associationId, data) => {
  const response = await api.put(`/admin/state-associations/${associationId}/verify`, data);
  return response.data;
},

bulkVerifyStateAssociations: async (data) => {
  const response = await api.post('/admin/state-associations/bulk-verify', data);
  return response.data;
},

deleteStateAssociation: async (associationId) => {
  const response = await api.delete(`/admin/state-associations/${associationId}`);
  return response.data;
},

// Event Applications
  getAllEventApplications: async (filters = {}) => {
    const response = await api.get('/admin/event-applications', { params: filters });
    return response.data;
  },

  getEventApplicationById: async (applicationId) => {
    const response = await api.get(`/admin/event-applications/${applicationId}`);
    return response.data;
  },

  downloadApplicationFile: async (applicationId) => {
    const response = await api.get(`/admin/event-applications/${applicationId}/download`);
    return response.data;
  },

  reviewEventApplication: async (applicationId, data) => {
    const response = await api.put(`/admin/event-applications/${applicationId}/review`, data);
    return response.data;
  },

  getApplicationStatistics: async (filters = {}) => {
    const response = await api.get('/admin/event-applications/statistics', { params: filters });
    return response.data;
  },

exportEventApplications: async (filters = {}) => {
  const response = await api.get('/admin/event-applications/export', { 
    params: filters,
    responseType: 'text'
  });
  return response.data;
},
};

export { default as athleteEventAPI } from './athleteEvent.api';